import { Util } from './../../../shared/Util';
import { ControlStatusService } from './../../../shared/control-status.service';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormField } from '../formulario-relatorios';
import { data } from 'jquery';
import { NgSwitch, NgSwitchCase, NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-input-relatorios',
    templateUrl: './input-relatorios.component.html',
    styleUrls: ['./input-relatorios.component.css'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgSwitch, NgSwitchCase, NgIf, NgFor]
})
export class InputRelatoriosComponent implements OnInit {

  @Input() input: FormField<string>;
  @Input() form: FormGroup;

  dataInicial: string = ''
  dataFinal: string = ''
  msgAviso: string = '';
  controleDataValida: boolean = false;

  constructor(public controlStatus: ControlStatusService, private util: Util) { }


  ngOnInit(): void {

  }

  setDataFiltroPeriodo(numero: number): void {
    let data = new Date();
    this.dataFinal = this.util.dataAtual();
    this.dataInicial = this.util.filtroData(data, numero);
  }

  atualizaDataInicial(dataInicial: string) {
    this.controlStatus.dataInicio = this.form.controls['dtInicio'].value
    this.dataInicial = this.controlStatus.dataInicio
    this.verificaPeriodoData()
  }

  atualizaDataFinal(dataFinal: string) {
    this.controlStatus.dataFim = this.form.controls['dtFinal'].value
    this.dataFinal = this.controlStatus.dataFim
    this.verificaPeriodoData()
  }

  verificaPeriodoData() {
    if (this.controlStatus.dataInicio > this.controlStatus.dataFim) {
      this.msgAviso = 'Data inicial deve ser menor que a data final.';
      this.controleDataValida = true;
    }
    else if (this.verificaPeriodoMaximo()) {

      this.msgAviso = 'Período máximo de 45 dias'
      this.controleDataValida = true;
    }
    else {

      this.msgAviso = '';
      this.controleDataValida = false;
    }
  }

  verificaPeriodoMaximo() {
    let umDiaMilissegundos = 1000 * 60 * 60 * 24;
    let diferencaMilissegundos = new Date(this.controlStatus.dataFim).getTime() - new Date(this.controlStatus.dataInicio).getTime();
    let diferencaDeDias = diferencaMilissegundos / umDiaMilissegundos;
    return diferencaDeDias > 45 ? true : false
  }


  get isValid() {

    if (this.controleDataValida == true) {
      return this.form.controls['dtFinal'].invalid && this.form.controls['dtInicio'].invalid
    }


    return this.form.controls[this.input.key].valid;
  }


}
